import { render } from "./MusicItem.vue?vue&type=template&id=033d83b1"
import script from "./MusicItem.vue?vue&type=script&lang=js"
export * from "./MusicItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/florianroscher/Sites/simtschuk-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__